<template>
    <div class="fondo">
         <!-- mensajes de confirmacion -->
        <mensajeSistema/>
        <Principal/>
        <Portafolio/>
        <Contacto/>

    </div>
</template>



<script>
    import {mapMutations} from 'vuex';
    import Principal from './Principal.vue';

    // Nosotros
    // import QuienSomos from './nosotros/QuienSomos.vue';
    import Portafolio from './nosotros/Portafolio.vue';

    // Contactos
    import Contacto from './Contacto.vue';

    export default {
        name:'Home',

     
        components: {
            Principal,
            Portafolio,
            Contacto,

        },

    

        mounted() {
            // this.loadMain()
        },


        data: () => ({

        }),


        methods: {

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////


            loadMain(){
                this.setEnviarMens({tipo:"S", mensaje: `Sistema Web Iniciado`, tiempo:null})
            },


        },
    };
</script>



<style scoped>

    .text_style{
        font-family: "avenir black";
        letter-spacing: 0.42px;
    }

    .fondo {

        background-image: url("~@/assets/img/bgMain.png");
        background-attachment: fixed;
        background-position: center;
        background-size: cover;
    }



</style>

